module.exports = __webpack_public_path__ + "img/invoiceInsertAct.28d095a1.png";